import React, { useEffect, useState } from "react";
import api from "../api/axios";

function BalanceSheet() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [toDate, setToDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  const token = localStorage.getItem("accessToken");

  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  useEffect(() => {
    fetchBalanceSheet();
  }, []);

  const fetchBalanceSheet = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/reports/balance-sheet?branch_id=${branch_id}&to_date=${toDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!data) return null;

  return (
    <div className="container-fluid mt-3">
      <div className="card">
        <div className="card-body">
          <h4 className="text-center mb-0">Balance Sheet</h4>
          <p className="text-center text-muted">As on {data.as_on}</p>

          <div className="row">
            {/* ================= ASSETS ================= */}
            <div className="col-md-6">
              <table className="table table-sm">
                <thead className="table-light">
                  <tr>
                    <th>Assets</th>
                    <th className="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <ReportTreeRows node={data.assets} />
                </tbody>
                <tfoot>
                  <tr className="fw-bold">
                    <td>Total Assets</td>
                    <td className="text-end">
                      {formatAmount(data.total_assets)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* ============ LIABILITIES & CAPITAL ============ */}
            <div className="col-md-6">
              <table className="table table-sm">
                <thead className="table-light">
                  <tr>
                    <th>Liabilities & Capital</th>
                    <th className="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Liabilities */}
                  {/* <tr className="fw-bold">
                    <td colSpan={2}>Liabilities</td>
                  </tr> */}
                  <ReportTreeRows node={data.liabilities} />
                  <tr className="fw-bold">
                    <td>Total Liabilities</td>
                    <td className="text-end">
                      {formatAmount(data.total_liabilities)}
                    </td>
                  </tr>

                  {/* Capital */}
                  <tr className="fw-bold">
                    <td colSpan={2}>&nbsp;</td>
                  </tr>
                  <tr className="fw-bold pt-2">
                    <td colSpan={2}>Capital</td>
                  </tr>
                  <ReportTreeRows node={data.capital} />
                  <tr className="fw-bold">
                    <td>Total Capital</td>
                    <td className="text-end">
                      {formatAmount(data.total_capital)}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr className="fw-bold">
                    <td colSpan={2}>&nbsp;</td>
                  </tr>
                  <tr className="fw-bold">
                    <td>Total Liabilities & Capital</td>
                    <td className="text-end">
                      {formatAmount(data.total_liabilities_capital)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Difference warning */}
          {data.difference !== 0 && (
            <p className="text-danger fw-bold mt-2">
              Difference: {formatAmount(data.difference)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

/* =========================================================
 * Recursive Table Rows Renderer
 * ========================================================= */

function ReportTreeRows({ node, level = 1 }) {
  if (!node) return null;

  return (
    <>
      {/* GROUP ROW */}
      <tr className="fw-semibold">
        <td style={{ paddingLeft: level * 15 }}>
          {node.group_name}
        </td>
        <td className="text-end">
          {formatAmount(node.amount)}
        </td>
      </tr>

      {/* CHILDREN */}
      {node.children?.map((child, index) => {
        if (child.type === "ledger") {
          return (
            <tr key={index}>
              <td style={{ paddingLeft: (level + 1) * 15 }}>
                {child.ledger_name}
              </td>
              <td className="text-end">
                {formatAmount(child.amount)}
              </td>
            </tr>
          );
        }

        return (
          <ReportTreeRows
            key={index}
            node={child}
            level={level + 1}
          />
        );
      })}
    </>
  );
}

/* =========================================================
 * Helpers
 * ========================================================= */

function formatAmount(value) {
  if (value === null || value === undefined) return "0.00";

  return Math.abs(Number(value)).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default BalanceSheet;